import { request } from '@/api/request';

/**
 * 获取企业信息
 * @returns Promise<any>
 */
export function getEnterpriseInfo(): Promise<any> {
  return request({
    url: '/id-enterprise/api/enterprise-info',
    method: 'GET',
  });
}

/**
 * 获取企业详情（当前企业，按 x-enterprise-id 区分）
 * @returns Promise<Company.EnterpriseDetailResponse>
 */
export function getEnterpriseDetail(): Promise<Company.EnterpriseDetailResponse> {
  return request({
    url: '/id-enterprise/api/enterprise-info/detail',
    method: 'GET',
  });
}

/**
 * 检查企业名称是否存在
 * @param name 企业名称
 * @returns Promise<Company.CheckNameExistsResponse>
 */
export function checkEnterpriseNameExists(name: string): Promise<Company.CheckNameExistsResponse> {
  return request({
    url: '/id-enterprise/api/enterprise-info/check-name-exists',
    method: 'GET',
    params: { name }
  });
}

/**
 * 创建或更新企业信息
 * @param params 企业信息参数
 * @param params.enterpriseInfo 企业信息对象
 * @param params.industryIds 行业ID列表
 * @returns Promise<any>
 */
export function saveEnterpriseInfo(params: Company.SaveEnterpriseInfoParams): Promise<any> {
  return request({
    url: '/id-enterprise/api/enterprise-info',
    method: 'POST',
    data: params
  });
}

/**
 * 获取猎头公司详情（含有料職業紹介許可証等猎头特有字段）
 * @returns Promise<Company.RecruiterDetailResponse>
 */
export function getRecruiterDetail(): Promise<Company.RecruiterDetailResponse> {
  return request({
    url: '/id-enterprise/api/enterprise-info/recruiter/detail',
    method: 'GET',
  });
}

/**
 * 保存猎头公司信息
 * @param params 猎头公司信息参数
 * @returns Promise<any>
 */
export function saveRecruiterInfo(params: Company.SaveRecruiterInfoParams): Promise<any> {
  return request({
    url: '/id-enterprise/api/enterprise-info/recruiter',
    method: 'POST',
    data: params
  });
}

/**
 * 上传文件（logo、許可証等图片）
 * @param file 上传的文件
 * @returns Promise<Company.UploadFileResponse>
 */
export function uploadFile(file: File): Promise<Company.UploadFileResponse> {
  const formData = new FormData();
  formData.append('file', file);

  return request({
    url: '/ats-candidate/api/v1/candidate/upload',
    method: 'POST',
    data: formData
  });
}

/**
 * 下载附件
 * @param params s3Key 与文件名
 * @returns Promise<Blob>
 */
export function downloadAttachmentApi(params: {
  s3Key: string
  fileName: string
}): Promise<Blob> {
  return request({
    url: '/rs-employee/api/v1/employee/download',
    method: 'GET',
    params,
    responseType: 'blob'
  })
}
